















































































































































































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import PrettyCheck from 'pretty-checkbox-vue/check';
import { useFormat, useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import useAuth from '@/useAuth';
import visitor from '@/table/visitor';
import useAxios from '@/useAxios';

import {
  getVisitors,
  getVisitorPin,
  deleteVisitor,
  deleteVisitors,
  activateVisitor,
  sendConfirmRegisterEmailToVisitor,
  forceLogout,
  getVisitorAsCSV,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';

const List = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
    CommonDropzoneWithAxios,
  },
  setup() {
    const { route, routerPersist, router } = useRouter(['searchString', 'searchStatus', 'date', 'page', 'sort']);
    const { hasPermission } = useAuth();
    const { axios } = useAxios();
    // const { isMobile } = useScreenWidth();

    const loading = ref(true);
    const visitors = ref([]);
    const pagination = ref({
      // eslint-disable-next-line
      current_page: 1,
    });
    const page = ref(1);
    const sort = ref({ field: 'created_at', order: 'DESC' });

    const from = ref('');
    const to = ref('');
    const searchString = ref('');
    const searchPaymentStatus = ref('');
    const searchActiveStatus = ref('');
    const searchLastLoginStatus = ref('');
    const refetchQuery = ref(false);
    const refetchQueryHandler = _.debounce(() => {
      refetchQuery.value = true;
    }, 250);
    const visitorsVariables = computed(() => {
      const vars = {
        admin: false,
        filterName: undefined,
        filterPaymentStatus: undefined,
        filterActive: undefined,
        filterByDateRange: undefined,
        filterLastLogin: undefined,
      };
      if (searchString.value) vars.filterName = searchString.value as any;
      if (searchPaymentStatus.value) vars.filterPaymentStatus = searchPaymentStatus.value as any;
      if (searchActiveStatus.value) vars.filterActive = searchActiveStatus.value as any;
      if (from.value) vars.filterByDateRange = from.value as any;
      if (searchLastLoginStatus.value === 'true') vars.filterLastLogin = (true as any);
      else if (searchLastLoginStatus.value === 'false') vars.filterLastLogin = (false as any);

      return vars;
    });

    const receiveNewData = async (data: any) => {
      visitors.value = data.data;
      // loading.value = true;
      // const { data, ...paginatorData } = await getVisitors(
      //   page.value,
      //   30,
      //   sort.value,
      //   searchString.value,
      //   searchPaymentStatus.value,
      //   searchActiveStatus.value,
      //   from.value,
      //   to.value,
      // );
      // visitors.value = (data as any).map((elm: any) => ({ ...elm, _secondaryControls: false }));
      // pagination.value = paginatorData;
      // loading.value = false;
    };

    watch(() => searchString.value, _.debounce(async (newVal, oldVal) => {
      if (newVal !== oldVal) {
        if (newVal && newVal !== '') {
          page.value = 1;
          router.push({
            name: 'VisitorList',
            query: {
              ...route.value.query,
              searchString: searchString.value,
            },
          });
        } else if (newVal === '') {
          page.value = 1;
          router.push({
            name: 'VisitorList',
            query: {
              ...route.value.query,
              searchString: undefined,
            },
          });
        }
        refetchQueryHandler();
      }
    }, 500));

    async function pendingSearchPaymentStatus() {
      if (searchPaymentStatus.value !== '') {
        page.value = 1;
        router.push({
          name: 'VisitorList',
          query: {
            ...route.value.query,
            searchPaymentStatus: searchPaymentStatus.value,
          },
        });
      } else {
        page.value = 1;
        router.push({
          name: 'VisitorList',
          query: {
            ...route.value.query,
            searchPaymentStatus: undefined,
          },
        });
      }
      refetchQueryHandler();
    }

    async function pendingSearchActiveStatus() {
      if (searchActiveStatus.value !== '') {
        page.value = 1;
        router.push({
          name: 'VisitorList',
          query: {
            ...route.value.query,
            searchActiveStatus: searchActiveStatus.value,
          },
        });
      } else {
        page.value = 1;
        router.push({
          name: 'VisitorList',
          query: {
            ...route.value.query,
            searchLoginStatus: undefined,
          },
        });
      }
      refetchQueryHandler();
    }

    async function pendingSearchLoginStatus() {
      if (searchActiveStatus.value !== '') {
        page.value = 1;
        router.push({
          name: 'VisitorList',
          query: {
            ...route.value.query,
            searchLoginStatus: searchLastLoginStatus.value,
          },
        });
      } else {
        page.value = 1;
        router.push({
          name: 'VisitorList',
          query: {
            ...route.value.query,
            searchLoginStatus: undefined,
          },
        });
      }
      refetchQueryHandler();
    }

    const navigateToDate = (date: any) => {
      if (useFormat.date(date).computerShortDate() === useFormat.date(route.value.query.date).computerShortDate()) {
        router.push({
          name: 'VisitorList',
        });
      } else {
        router.push({
          name: 'VisitorList',
          query: {
            ...route.value.query,
            date: useFormat.date(date).computerShortDate(),
          },
        });
      }
    };
    watch(() => route.value.query.date, async (newVal, oldVal) => {
      // eslint-disable-next-line
      if (newVal !== oldVal) {
        from.value = newVal;
        to.value = newVal;
        refetchQueryHandler();
      }
    });

    const setActiveStatus = async (id: number, status: boolean) => {
      const index = visitors.value.findIndex((elm: any) => elm.id === id);
      await activateVisitor(id, !status);
      (visitors.value[index] as any).active = !status;
    };

    // ==================== //
    // Use with select item //
    const selectedItems: Ref<number[]> = ref([]);
    const selectItem = (id: number, status: boolean) => {
      if (status) {
        const removeIndex = selectedItems.value.findIndex((elm: any) => elm === id);
        if (removeIndex > -1) selectedItems.value.splice(removeIndex, 1);
      } else {
        selectedItems.value.push(id);
      }
      const index = visitors.value.findIndex((elm: any) => elm.id === id);
      (visitors.value[index] as any)._secondaryControls = !status;
    };
    const selectAllItems = () => {
      if (selectedItems.value.length > 0) selectedItems.value.splice(0, selectedItems.value.length);
      visitors.value.forEach((elm: any, index: number) => {
        (visitors.value[index] as any)._secondaryControls = true;
        selectedItems.value.push(elm.id);
        console.log(elm);
      });
      console.log(selectedItems.value);
    };
    const unselectAllItems = () => {
      selectedItems.value.splice(0, selectedItems.value.length);
      visitors.value.forEach((elm: any, index: number) => {
        (visitors.value[index] as any)._secondaryControls = false;
      });
    };

    // Delete fn
    const deleteItemModal = ref(null);
    const deleteItemsModal = ref(null);
    const openDeleteVisitorModal = (item: any) => {
      (deleteItemModal.value as any).compose({
        id: item.id,
        action: 'ลบ',
        entity: 'ผู้เข้าร่วมงาน',
        body: `เป็นการลบ<br>${item.name}<br>จากระบบโดยถาวร<br>ไม่สามารถย้อนคืนได้`,
      });
    };
    const deleteItemAction = async (id: number) => {
      const result = await deleteVisitor(id);
      refetchQueryHandler();
    };
    const deleteItemsAction = async () => {
      const result = await deleteVisitors(selectedItems.value);
      refetchQueryHandler();
    };

    const showPinModal = ref(null);
    const user = reactive({
      pin: '',
    });
    async function getVisitorPinAction(id: number) {
      const { data } = await getVisitorPin(id);
      user.pin = data.new_pin;
      (showPinModal.value as any).open();
    }

    async function downloadReport() {
      await getVisitorAsCSV(visitorsVariables.value);
    }

    const sendEmailCompleteModal = ref(null);
    async function sendRegisterEmailToVisitor(userId: number) {
      const result = await sendConfirmRegisterEmailToVisitor(userId);
      if (result) {
        (sendEmailCompleteModal.value as any).compose({ action: 'ส่ง', entity: 'อีเมลเรียบร้อย' });
      }
    }

    async function kickUserAction(userId: number) {
      const result = await forceLogout(userId);
      if (result === true) (sendEmailCompleteModal.value as any).compose({ action: 'บังคับ', entity: 'ผู้ใช้ ออกจากระบบ สำเร็จ' });
    }

    const showUploadResultModal = ref(null);
    async function uploadFileDoneAction(axiosResult: any) {
      // count: 11
      // failed: 11
      // success: 0
      (showUploadResultModal.value as any).compose({ entity: 'นำเข้าข้อมูล', body: `ทั้งหมด: ${axiosResult.count} รายการ<br>สำเร็จ: ${axiosResult.success} รายการ<br>ข้อมูลซ้ำ: ${axiosResult.failed} รายการ` });
      refetchQueryHandler();
    }

    return {
      axios,

      visitors,
      visitorTableOptions: visitor,
      visitorsVariables,
      page,
      pagination,
      loading,
      searchString,
      searchPaymentStatus,
      searchActiveStatus,
      searchLastLoginStatus,
      pendingSearchPaymentStatus,
      pendingSearchActiveStatus,
      pendingSearchLoginStatus,
      from,
      to,

      // pendingSearch,
      getVisitors,

      sort,

      navigateToDate,
      setActiveStatus,

      selectItem,
      selectAllItems,
      selectedItems,
      unselectAllItems,

      openDeleteVisitorModal,
      deleteItemAction,
      deleteItemsAction,
      deleteItemModal,
      deleteItemsModal,

      showPinModal,
      getVisitorPinAction,
      user,

      hasPermission,

      downloadReport,

      sendEmailCompleteModal,
      sendRegisterEmailToVisitor,

      receiveNewData,

      // Kick user
      kickUserAction,

      showUploadResultModal,
      uploadFileDoneAction,

      refetchQuery,
      refetchQueryHandler,
    };
  },
});

export default List;
